import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ApiManufacturer, ApiV1Service } from 'api';
import { inject } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

export const ManufacturerResolver: ResolveFn<ApiManufacturer | RedirectCommand> = (): Observable<
  ApiManufacturer | RedirectCommand
> => {
  const apiService = inject(ApiV1Service);
  const router = inject(Router);

  return apiService.getCurrentManufacturer().pipe(
    catchError((error) => {
      console.error('Failed to load current manufacturer:', error);
      return of(new RedirectCommand(router.parseUrl('/manufacturer')));
    }),
  );
};
